import { 
  Card, 
  CardContent, 
  CardMedia, 
  CardActions, 
  Typography, 
  Button 
} from '@mui/material';

/**
 * Reusable card component with optional image, content, and actions
 */
export default function CardItem({ 
  title, 
  description, 
  imageUrl, 
  imageAlt, 
  actions,
  elevation = 1,
  sx = {}
}) {
  return (
    <Card 
      elevation={elevation} 
      sx={{ height: '100%', display: 'flex', flexDirection: 'column', ...sx }}
    >
      {imageUrl && (
        <CardMedia
          component="img"
          height="140"
          image={imageUrl}
          alt={imageAlt || title}
        />
      )}
      <CardContent sx={{ flexGrow: 1 }}>
        {title && (
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </CardContent>
      {actions && (
        <CardActions>
          {actions.map((action, index) => (
            <Button 
              key={index} 
              size="small" 
              color={action.color || "primary"}
              variant={action.variant || "text"}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </CardActions>
      )}
    </Card>
  );
} 